import React from 'react';

interface Billboard3DIconProps {
  size?: number;
  color?: string;
}

export const Billboard3DIcon = ({ size = 48, color = '#BC1A6C' }: Billboard3DIconProps) => {
  const darkerColor = adjustBrightness(color, -30);
  const lighterColor = adjustBrightness(color, 30);
  
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Shadow */}
      <ellipse cx="32" cy="58" rx="14" ry="3" fill="rgba(0,0,0,0.2)" />
      {/* Pole */}
      <rect x="29" y="38" width="3" height="18" fill={darkerColor} rx="1" />
      <rect x="30" y="38" width="3" height="18" fill={color} rx="1" />
      {/* Screen back (right side - darker) */}
      <path d="M48 12 L52 9 L52 33 L48 36 Z" fill={darkerColor} />
      {/* Screen top */}
      <path d="M12 12 L16 9 L52 9 L48 12 Z" fill={lighterColor} />
      {/* Screen front face */}
      <rect x="12" y="12" width="36" height="24" rx="2" fill={color} />
      {/* Screen inner */}
      <rect x="15" y="15" width="30" height="18" rx="1" fill="white" opacity="0.25" />
      {/* Play button / ad symbol */}
      <polygon points="28,21 28,29 36,25" fill="white" opacity="0.6" />
      {/* Screen shine */}
      <rect x="12" y="12" width="36" height="4" rx="2" fill="white" opacity="0.15" />
    </svg>
  );
};

function adjustBrightness(hex: string, amount: number): string {
  const num = parseInt(hex.replace('#', ''), 16);
  const r = Math.min(255, Math.max(0, (num >> 16) + amount));
  const g = Math.min(255, Math.max(0, ((num >> 8) & 0x00FF) + amount));
  const b = Math.min(255, Math.max(0, (num & 0x0000FF) + amount));
  return `#${(r << 16 | g << 8 | b).toString(16).padStart(6, '0')}`;
}
